/* RESPONSIBLE TEAM: team-data-foundations */
import BaseValidator from 'ember-cp-validations/validators/base';
import { isBlank } from '@ember/utils';
import type Model from '@ember-data/model';

export default class TestValuesNotBlank extends BaseValidator {
  validate(
    _value: unknown,
    _options: ValidationOptions,
    model: Model & { testValues?: Record<string, unknown> },
  ): boolean {
    let testValues = model.get('testValues');
    if (testValues && typeof testValues === 'object' && !Array.isArray(testValues)) {
      return !Object.values(testValues).some(isBlank);
    }
    return true;
  }

  static getDependentsFor(): string[] {
    return ['model.testValues'];
  }
}
